

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class PaymentInstallmentTemplateLine_ManagedObject

class PaymentInstallmentTemplateLine_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: offsetDays
    set offsetDays(value:number) {
        this.setValueForKey(value, 'offsetDays');
    }
    get offsetDays():number {
        return this.valueForKey('offsetDays');
    }
    set offsetDaysPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'offsetDays');
    }
    get offsetDaysPrimitiveValue():number {
        return this.primitiveValueForKey('offsetDays');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: percentage
    set percentage(value:number) {
        this.setValueForKey(value, 'percentage');
    }
    get percentage():number {
        return this.valueForKey('percentage');
    }
    set percentagePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'percentage');
    }
    get percentagePrimitiveValue():number {
        return this.primitiveValueForKey('percentage');
    }
    // Relationship: template
    set template(value:PaymentInstallmentTemplate) {
        this.setValueForKey(value, 'template');
    }
    get template():PaymentInstallmentTemplate {
        return this.valueForKey('template') as PaymentInstallmentTemplate;
    }
}
